import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import 'bootstrap/dist/css/bootstrap.css';
import './index.css';

// ✅ DO NOT export anything
function mountApp(container) {
  if (!container) {
    console.error("❌ No container to mount.");
    return;
  }

  const isInline = container.getAttribute('data-inline') === 'true';
  console.log(`✅ Mounting to ${container.id} | inline: ${isInline}`);

  // Safe rendering
  ReactDOM.render(<App inline={isInline} />, container);
}

// ✅ THIS IS CRITICAL: Attach it directly to window
window.ReactChatApp = mountApp;

// ✅ Optional auto-mount
const defaultContainer = document.getElementById('shelly-root');
if (defaultContainer) {
  window.ReactChatApp(defaultContainer);
}
